export const PLACE_DETAILS_FETCHED = 'PLACE_DETAILS_FETCHED';
export const PLACE_DETAIL_CREATE = 'PLACE_DETAIL_CREATE';
export const PLACE_DETAIL_UPDATE = 'PLACE_DETAIL_UPDATE';
export const PLACE_DETAIL_REMOVE = 'PLACE_DETAIL_REMOVE';
export const PLACE_DETAIL_ADD_DATA_TO_UPDATE = 'PLACE_DETAIL_ADD_DATA_TO_UPDATE';
export const PLACE_DETAIL_CLEAR_DATA_TO_UPDATE = 'PLACE_DETAIL_CLEAR_DATA_TO_UPDATE';
export const PLACE_DETAILS_STATUSES_FETCHED = 'PLACE_DETAILS_STATUSES_FETCHED';
